import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById("root")!;
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// The build captures browser-rendered HTML for discovery. It is not React SSR
// markup; mount normally so live Firebase state can replace the snapshot safely.
createRoot(container).render(app);
